import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { If, Button, Text, StatusIcon } from 'src/Components'

import styles from './RefiRequest.module.scss'

const RefiRequest = ({
  className,
  contactFirstName,
  onRequestRefi,
  withPrimaryButton,
  requested,
  success,
  messageProps,
  failure,
  label
}) => (
  <div
    className={classnames(
      styles.container,
      requested && styles.requested,
      className
    )}
  >
    <If condition={!requested && !success && !failure}>
      <Button
        primary={withPrimaryButton}
        onClick={() => onRequestRefi(label)}
        data-qa='prequalPrompt.confirmButton'
      >
        <FormattedMessage
          id='RefiRequest.request'
          defaultMessage='Have {contactFirstName} send you refi options'
          values={{ contactFirstName }}
          {...messageProps}
        />
      </Button>
    </If>
    <If condition={requested || success || failure}>
      <StatusIcon
        className={styles.icon}
        spin={!success && !failure}
        success={success}
        failure={failure}
      />
      <If condition={!success && !failure}>
        <Text size='l' weight='light'>
          <FormattedMessage
            id='RefiRequest.inFlight'
            defaultMessage='Contacting {contactFirstName}...'
            values={{ contactFirstName }}
          />
        </Text>
      </If>
      <If condition={success && !failure}>
        <Text size='l' weight='light'>
          <FormattedMessage
            id='RefiRequest.success'
            defaultMessage='Great! {contactFirstName} will be in contact shortly.'
            values={{ contactFirstName }}
          />
        </Text>
      </If>
      <If condition={!success && failure}>
        <Text size='l' weight='light'>
          <FormattedMessage
            id='RefiRequest.failure'
            defaultMessage='Request failed, unable to contact {contactFirstName}.'
            values={{ contactFirstName }}
          />
        </Text>
      </If>
    </If>
  </div>
)

export default RefiRequest
